<template lang="pug">
div.monitoring-detail.l-flex-column.scrollbar.is-scrollable
    Panel(panelClassName="dsp-configuration-details-panel")
        template(slot="content")
            section.detail-section
                div.sub-header.l-flex-row--between
                    div.sub-header-title Details
                div.info-content
                    div.info-block
                        div.label Label
                        div.editable-value
                            input.edit-single-input.configuration-label(
                                type="text"
                                :id="'label' + selectedDspConfiguration.id"
                                name="label"
                                placeholder="Choose a nice name for your configuration"
                                v-model="label"
                                :title="label"
                                v-validate="'max:200|required|ascii'"
                                @keyup.enter="editConfigInfo('label')")
                            span.form-validate-error {{ errors.first('label') }}

                    //- DPS CLIENT ID
                    div.info-block
                        div.label
                            span Identifier
                            span.list-counter(v-if="isMailRu") {{ mailRuArray.length }} /5

                        //- email only
                        template(v-show="dspClientIdEmail")
                            div.editable-value(v-if="dspLabel === dspKeyLabels.adobe" key="dsp_adobe_email")
                                input.edit-single-input.configuration-dsp-id-email(
                                    type="text"
                                    id="dsp_adobe_email"
                                    name="dsp_adobe_email"
                                    placeholder="Set your DSP Account Email"
                                    v-model="dspClientId"
                                    v-validate="'max:255|email'"
                                    @keyup.enter="editConfigInfo('dspClientId')")
                                span.form-validate-error(v-if="adobeDspClientIdNotCorrect") Must be a valid adobe or tubemogul address

                            div.cursor.editable-value(v-if="isMailRu" @click="displayEdit()")
                                div.value.value-list
                                    span.value-item(v-for="(email, idx) of mailRuArray" :key="idx") {{ email }}
                                svg-icon.cursor.edit-action(name='edit' size="small")
                                button.btn--xsmall.btn-add(v-if="!displayMailRuEditForm && mailRuArray.length < 5" @click.stop="displayEdit()") + add

                        //- digits only
                        div.editable-value(v-show="dspClientIdDigit" key="dsp_digit")
                            input.edit-single-input.configuration-dsp-id-digits(
                                v-model="dspClientId"
                                :title="dspClientId"
                                placeholder="Set your DSP Account ID (digits only)"
                                id="dsp_digit"
                                name="dsp_digit"
                                v-validate="'max:255|decimal:no|required'"
                                type="number"
                                @keyup.enter="editConfigInfo('dspClientId')")
                            span.form-validate-error {{ errors.first('dsp_digit') }}

                        //- ascii only
                        div.editable-value(v-show="dspClientIdAscii")
                            input.edit-single-input.configuration-dsp-id-ascii(
                                v-model="dspClientId"
                                :title="dspClientId"
                                placeholder="Set your DSP Account ID (ascii characters only)"
                                id="dsp_ascii"
                                name="dsp_ascii"
                                v-validate="'max:255|required|ascii'"
                                type="text"
                                @keyup.enter="editConfigInfo('dspClientId')")
                            span.form-validate-error {{ errors.first('dsp_ascii') }}

                        //- snapchat only
                        div.editable-value(v-show="dspLabel === dspKeyLabels.snapchat")
                            input.edit-single-input.configuration-dsp-id-ascii(
                                v-model="dspClientId"
                                :title="dspClientId"
                                placeholder="Set your snapchat ad account id"
                                id="snapchat_ad_account_id"
                                name="snapchat_ad_account_id"
                                v-validate="'max:255|required|ascii'"
                                type="text"
                                @keyup.enter="editConfigInfo('dspClientId')")
                            span.form-validate-error {{ errors.first('snapchat_ad_account_id') }}
                        //- datahub only
                        div.value(v-show="dspLabel === dspKeyLabels.datahub") {{ dspClientId }}
                    //- Modal single edit for MailRu
                    transition(name="slide-fade")
                        div.edit-single-wrapper(v-show="displayMailRuEditForm")
                            EmailCcField(
                                parent="DspConfigurationDetails"
                                placeholder="Add, edit a DSP Account Email"
                                :defaultValues="mailRuArray"
                                :maxItems="5"
                                :cleanInput="emptyMailRuInput"
                                @formCcListUpdate="updateFormCcList"
                            )

                            footer.l-flex-row--rev
                                button.btn-cancel.btn--small.btn--round(@click="cancelMailRuEdit()") cancel
                                button.btn.btn-pale.btn--small.btn--round(:class="{ 'ui-disabled': disableMailRuSave }" @click="editConfigInfo('dspClientId')") save

                    div.info-block
                        div.label Transfer type
                        div.value {{ formatTransferType }}

            section.detail-section(v-if="selectedDspConfiguration.extra_info !== ''")
                div.sub-header.l-flex-row--between
                    div.sub-header-title Extra info

                template(v-if="parsedExtraInfo !== null")
                    div.info-content(v-if="parsableExtraInfo" v-for="(value, key) in parsedExtraInfo" :key="key")
                        div.info-block
                            div.label {{ formatParsedExtraInfoKey(key) }}
                            //- div.editable-value
                                input.edit-single-input.configuration-label(
                                    type="text"
                                    :id="'extra info' + key"
                                    :name="'extra info' + key"
                                    :key="'extra info' + key"
                                    :placeholder="'Edit extra info ' + key"
                                    v-model="parsedExtraInfo[key]"
                                    :title="label"
                                    v-validate="'max:200|required|ascii'"
                                    @keyup.enter="editExtraInfo(key, parsedExtraInfo[key])")
                            div.value(:title="parsedExtraInfo[key]") {{ mapExtractedValue(parsedExtraInfo[key]) }}
                                span.form-validate-error {{ errors.first('extra info' + ' ' + key) }}
                    div.info-content(v-if="!parsableExtraInfo")
                        div.info-block
                            div.label {{ unparsableExtraInfo() }}
                            //- div.editable-value
                                input.edit-single-input.configuration-label(
                                    type="text"
                                    id="extra-info-unparsable"
                                    name="extra-info-unparsable"
                                    key="extra-info-unparsable"
                                    :placeholder="'Edit extra info'"
                                    v-model="selectedDspConfiguration.extra_info"
                                    :title="label"
                                    v-validate="'max:200|required|ascii'"
                                    @keyup.enter="editExtraInfo(unparsableExtraInfo(), selectedDspConfiguration.extra_info, true)")
                                span.form-validate-error {{ errors.first('extra-info-unparsable') }}
                            div.value(:title="selectedDspConfiguration.extra_info") {{ mapExtractedValue(selectedDspConfiguration.extra_info) }}

                p.no-extra-info(v-else) Unable to retrieve extra infos.

        template(slot="footer")
            a.btn.btn-authorize.btn--medium.btn--round.l-flex-row--center.l-align-center(
                v-if="dspLabel === 'tiktok' && !parsedExtraInfo.is_authenticated"
                :href="urlActivationTiktok"
                target="_blank"
                @click="getStatusAuthenticated(selectedDspConfigurationId)"
                :disabled="currentDspDisabled"
                :class="{ 'disabled': currentDspDisabled }"
            )
                svg-icon(name='lock' size='small')
                | Authorize Weborama as object manager
                spinner(
                    v-if="currentDspDisabled" size='small'
                    width="20"
                    height="20"
                )
            //- Delete config
            .delete-configuration.btn.btn-delete.btn--medium.btn--round.l-flex-row--center.l-align-center(@click="deleteConfigHandler()")
                svg-icon(name='trash' size='small')
                | Delete configuration
</template>

<script>
//avoid repeating namespace for each store action/mutation/getter/state
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex'

//components
import Panel from '@/components/common/Panel'
import EmailCcField from '@/components/common/EmailCcField'

import { clone, isEmpty, isNil, find, join, map, replace, startCase, toNumber, trim, uniq } from 'lodash'
import { DSP_KEY_LABELS } from '@/utils/constants'

export default {
    name: 'DspConfigurationDetails',

    components: { Panel, EmailCcField },

    mounted() {
        this.initializeData()
    },

    data() {
        return {
            dspLabel: null,
            label: null,
            dspClientId: null,
            displayMailRuEditForm: false,
            mailRuArray: [],
            emptyMailRuInput: false,
            isDisabled: false,
            idsDspAuthorize: []
        }
    },

    watch: {
        selectedDspConfigurationId: {
            handler: function(newValue) {
                if (!isNil(newValue)) this.initializeData()
            }
        },
        dspClientId: {
            handler: function(newValue) {
                if (this.isMailRu) {
                    this.mailRuArray = isEmpty(newValue) ? [] : map(newValue.split(','), trim)
                }
            }
        }
    },

    computed: {
        ...mapState('ui/dsp', {
            selectedDspConfigurationId: state => state.selectedRowId
        }),

        ...mapState('data/accountsDsps', {
            accountsDspsList: state => state.list
        }),

        ...mapState('account', {
            accountId: state => state.accountId
        }),

        ...mapGetters('ui/dsp', ['getSimpleDspList']),
        dspList() {
            return this.getSimpleDspList()
        },

        currentDspDisabled() {
            return this.idsDspAuthorize.indexOf(this.selectedDspConfigurationId) !== -1
        },

        dspKeyLabels() {
            return DSP_KEY_LABELS
        },

        formatTransferType() {
            let transferType = ''
            if (this.selectedDspConfiguration.transfer_type === '1stparty') transferType = '1st Party'
            else if (this.selectedDspConfiguration.transfer_type === '3rdparty') transferType = '3rd Party'
            return transferType
        },

        parsedExtraInfo() {
            if (this.selectedDspConfiguration.extra_info === '') return null
            let _extraInfo

            if (!this.parsableExtraInfo && !isEmpty(this.selectedDspConfiguration.extra_info)) _extraInfo = this.selectedDspConfiguration.extra_info
            else {
                try {
                    _extraInfo = JSON.parse(this.selectedDspConfiguration.extra_info)
                } catch (e) {
                    _extraInfo = null
                }
            }

            if (!isNil(_extraInfo)) {
                return Object.keys(_extraInfo)
                    .sort()
                    .reduce((obj, key) => {
                        obj[key] = _extraInfo[key]
                        return obj
                    }, {})
            }
            return {}
        },

        parsableExtraInfo() {
            return (
                this.dspLabel !== this.dspKeyLabels.genericDsp &&
                this.dspLabel !== this.dspKeyLabels.googleCloudStorage &&
                this.dspLabel !== this.dspKeyLabels.googleDmp &&
                this.dspLabel !== this.dspKeyLabels.theTradeDesk
            )
        },

        selectedDspConfiguration() {
            let accountsDsp = this.accountsDspsList.find(account => account.id === this.selectedDspConfigurationId)

            if (!this.parsableExtraInfo) {
                try {
                    const parsed = JSON.parse(accountsDsp.extra_info)
                    if (typeof parsed === 'object') {
                        accountsDsp = { ...accountsDsp, extra_info: Object.values(parsed)[0] }
                    }
                } catch {
                    // empty
                }
            }
            return { ...accountsDsp }
        },

        //client id
        dspClientIdEmail() {
            return this.dspLabel === this.dspKeyLabels.adobe || this.isMailRu
        },

        adobeDspClientIdNotCorrect() {
            const regex = /^([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)@(adobe|tubemogul)\.com$/
            return this.dspLabel === this.dspKeyLabels.adobe && !regex.test(this.dspClientId)
        },

        isMailRu() {
            return this.dspLabel === this.dspKeyLabels.mailRu
        },

        disableMailRuSave() {
            return isEmpty(this.dspClientId) || this.dspClientId === this.selectedDspConfiguration.dsp_client_id
        },

        theTradeDeskFirstParty() {
            return this.dspLabel === this.dspKeyLabels.theTradeDesk && this.selectedDspConfiguration.transfer_type === '1stparty'
        },

        theTradeDeskThirdParty() {
            return this.dspLabel === this.dspKeyLabels.theTradeDesk && this.selectedDspConfiguration.transfer_type === '3rdparty'
        },

        dspClientIdAscii() {
            return (
                this.theTradeDeskFirstParty ||
                this.theTradeDeskThirdParty ||
                this.dspLabel === this.dspKeyLabels.rubicon ||
                this.dspLabel === this.dspKeyLabels.utiqEquativ ||
                this.dspLabel === this.dspKeyLabels.smartAdServer ||
                this.dspLabel === this.dspKeyLabels.yandex
            )
        },

        dspClientIdDigit() {
            if (this.dspLabel !== this.dspKeyLabels.theTradeDesk)
                return !this.dspClientIdEmail && !this.dspClientIdAscii && this.dspLabel !== this.dspKeyLabels.snapchat && this.dspLabel !== this.dspKeyLabels.datahub
            else return null
        },

        urlActivationTiktok() {
            return `${process.env.VUE_APP_TIKTOK_AUTHORIZE}?wam_account_id=${this.accountId}&partner_config_id=${this.selectedDspConfigurationId}`
        }
    },

    beforeDestroy() {
        this.$validator.pause()
    },

    methods: {
        ...mapMutations('ui/dsp', ['setSelectedRow', 'setDisplayModal', 'setDeletedConfig']),
        ...mapMutations('data/accountsDsps', ['setUpdatedAccountsDsp']),
        ...mapActions('data/accountsDsps', ['updateAccountsDsp', 'getAccountsDsp']),
        ...mapActions('data/transfer', ['retrieveAccountsDspActiveTransfers']),

        initializeData() {
            this.label = this.selectedDspConfiguration.label
            this.dspClientId = clone(this.selectedDspConfiguration.dsp_client_id)

            const selectedConfigDsp = find(this.dspList, _dsp => toNumber(_dsp.id) === toNumber(this.selectedDspConfiguration.dsp_id))

            this.dspLabel = selectedConfigDsp.keyLabel
            if(this.idsDspAuthorize.indexOf(this.selectedDspConfigurationId) === -1) this.isDisabled = false
            if (this.isMailRu) {
                this.mailRuArray = isEmpty(this.dspClientId) ? [] : map(this.dspClientId.split(','), trim)
            }
            this.retrieveAccountsDspActiveTransfers({ accounts_dsp_id: toNumber(this.selectedDspConfigurationId) })
        },
        formatParsedExtraInfoKey(key) {
            return startCase(replace(key, /_/g, ' '))
        },
        unparsableExtraInfo() {
            if (this.dspLabel === 'googledmp') {
                return 'Configuration type'
            } else if (this.dspLabel === 'thetradedesk') {
                return 'Secret Key'
            }

            return this.selectedDspConfiguration.partnerLabel
        },

        // DELETE
        deleteConfigHandler() {
            this.setDisplayModal({ item: 'confirmation', display: true })
            this.setDeletedConfig({ id: this.selectedDspConfigurationId })
        },

        // EDIT
        preventEdit(infoToEdit) {
            if (infoToEdit === 'dspClientId') {
                if (this.dspLabel === this.dspKeyLabels.adobe) {
                    return this.errors.has('dsp_adobe_email') && this.adobeDspClientIdNotCorrect
                } else if (this.dspClientIdDigit) {
                    return this.errors.has('dsp_digit')
                } else if (this.dspClientIdAscii) {
                    return this.errors.has('dsp_ascii')
                } else {
                    return this.errors.has('mail_ru_email')
                }
            } else if (infoToEdit === 'label') {
                return this.errors.has('label')
            }
        },

        editConfigInfo(info) {
            if (this.preventEdit(info)) return
            if (this.isMailRu && info === 'dspClientId') this.displayEdit()
            const params = info === 'label' ? { label: this.label } : { dsp_client_id: this.dspClientId }
            this.updateAccountsDsp(params).then(response => {
                if (response !== 'success') {
                    //reset infos to their original values
                    this.dspClientId = this.selectedDspConfiguration.dsp_client_id
                }
            })
        },

        editExtraInfo(extraInfoKey, extraInfoValue, isUnparsable) {
            const parsedExtraInfo = this.parsedExtraInfo
            const item = { [extraInfoKey]: extraInfoValue }
            const params = isUnparsable ? { extra_info: { ...item } } : { extra_info: { ...parsedExtraInfo, ...item } }
            this.updateAccountsDsp(params).then(response => {
                if (response !== 'success') {
                    //reset infos to their original values
                    this.dspClientId = this.selectedDspConfiguration.dsp_client_id
                }
            })
        },

        // MailRu dspClientId edit
        updateFormCcList(ccList) {
            this.mailRuArray = ccList
            this.dspClientId = join(uniq(this.mailRuArray.concat(ccList)).slice(0, 5), ',')
        },
        displayEdit() {
            this.displayMailRuEditForm = !this.displayMailRuEditForm
        },
        cancelMailRuEdit() {
            this.emptyMailRuInput = !this.emptyMailRuInput
            this.dspClientId = this.selectedDspConfiguration.dsp_client_id
            this.mailRuArray = isEmpty(this.dspClientId) ? [] : map(this.dspClientId.split(','), trim)
            this.displayEdit()
        },
        getStatusAuthenticated(id, requestTry = 0) {
            if(this.idsDspAuthorize.indexOf(id) === -1) {
                this.isDisabled = true
                this.idsDspAuthorize.push(id)
            }
            const index = this.idsDspAuthorize.indexOf(id)
            if(requestTry < 20) {
                setTimeout(() => {
                    this.getAccountsDsp(id).then((response) => {
                        if(!JSON.parse(response.extra_info).is_authenticated) {
                            requestTry++
                            this.getStatusAuthenticated(id, requestTry)
                        } else {
                            this.setUpdatedAccountsDsp({ item: response })
                            this.isDisabled = false
                            this.idsDspAuthorize.splice(index, 1)
                        }
                    })
                }, 5000)
            }else {
                this.isDisabled = false
                this.idsDspAuthorize.splice(index, 1)
            }
        },
        mapExtractedValue(value) {
            const mappingValues = {
                'DFP_BY_GOOGLE': 'GAM',
                'INVITE_ADVERTISER': 'DV360 Advertiser',
                'INVITE_PARTNER': 'DV360 Partner',
                'ADWORDS': 'Google Ads',
                'GOOGLE_AD_MANAGER': 'GAM',
                'DISPLAY_VIDEO_ADVERTISER': 'DV360 Advertiser',
                'DISPLAY_VIDEO_PARTNER': 'DV360 Partner'
            }
            return mappingValues[value] || value
        }
    }
}
</script>
<style lang="scss">
.dsp-configuration-details-panel {
    .btn-delete.btn--medium {
        margin-left: 0;
        margin-top: 24px;
    }
    .btn-authorize {
        line-height: 18px;
        .icon {
            margin-right: 8px;
            height: 12px;
        }
        &.disabled {
            background-color: var(--color-danger)!important;
            color: white!important;
            border-color: var(--color-danger)!important;
        }
        .spinner-wrapper {
            margin-left: 16px;
            max-width: 20px;
            display: flex;
            align-items: center;
            path {
                stroke: #fff;
            }
        }
    }
    footer {
        padding: 0;
    }
}
</style>
